import React, {useContext, useEffect} from 'react';
import {ContextAppState} from "@app/context.ts";
import {TopBar} from "@pages/account/components/top-bar";
import {AccountActions} from "@pages/account/components/action";
import {ListTokenBalance} from './components/list-token';
import {useGetWallet} from "@hooks/wallet.ts";
import {ShowNative} from "./components/native";
import Decimal from "decimal.js";

export const AccountPage: React.FC = () => {
    let appState = useContext(ContextAppState);
    const [wallet, walletLoading, walletError, getWallet] = useGetWallet();

    useEffect(() => {
        const abortController = new AbortController();
        getWallet(appState.wallet.id, abortController)
        return () => abortController.abort();
    }, [getWallet]);

    if (walletLoading || !wallet) {
        return (<h1> Loading..</h1>)
    }

    return (
        <div className="relative">
            <div className="mb-4">
                <TopBar/>
            </div>
            <div className="mx-auto max-w-[1440px] px-4 pb-64 pt-4 md:px-6">
                <ShowNative amount={new Decimal(wallet.native?.amount || "0")}/>
                <AccountActions address={wallet.address}/>
                <ListTokenBalance token={wallet.token}/>
            </div>

            <div className="mb-4">
                {/*<BottomBar/>*/}
            </div>

        </div>
    )
}


